import { useReducer } from 'react';
var updateReducer = function (num) { return (num + 1) % 1000000; };
var useUpdate = function () {
    var _a = useReducer(updateReducer, 0), update = _a[1];
    return update;
};
export default useUpdate;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useUpdate.js
// module id = u0pj
// module chunks = 0